import styled from '@emotion/styled';
import { device, useRevealTrail } from '@landsbankinn/ui';
import React from 'react';

export interface IProps {
  children: React.ReactNode;
  count: number;
}

const Host = styled.div<{ count: number }>`
  @media ${device.tablet} {
    display: -ms-grid;
    display: grid;
    gap: 15px 15px;
  }

  @media ${device.desktop} {
    gap: 20px 20px;
  }

  ${(props) => {
    switch (props.count) {
      case 2:
        return `
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr;
          grid-template-areas: 'item1 item1 item2';

          > *:first-child {
            grid-area: item1;
            background-color: ${props.theme.shades.secondary2};
          }

          > *:nth-child(2) {
            grid-area: item2;
            background-color: ${props.theme.shades.ternary2};
          }
        `;
      case 3:
        return `
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr;
          grid-template-areas: 'item1 item2 item3';

          > *:first-child {
            grid-area: item1;
            background-color: ${props.theme.shades.primary2};
          }

          > *:nth-child(2) {
            grid-area: item2;
            background-color: ${props.theme.shades.secondary2};
          }

          > *:nth-child(3) {
            grid-area: item3;
            background-color: ${props.theme.shades.ternary2};
          }
        `;
      case 4:
        return `
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr 1fr;
          grid-template-areas:
            'item1 item1 item2'
            'item3 item4 item4';

          > *:first-child {
            grid-area: item1;
            background-color: ${props.theme.shades.secondary2};
          }

          > *:nth-child(2) {
            grid-area: item2;
            background-color: ${props.theme.shades.ternary2};
          }

          > *:nth-child(3) {
            grid-area: item3;
            background-color: ${props.theme.shades.primary2};
          }

          > *:nth-child(4) {
            grid-area: item4;
            background-color: ${props.theme.colors.backgroundAlt};
          }
        `;
      case 5:
        return `
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr 1fr;
          grid-template-areas:
            'item1 item2 item3'
            'item4 item5 item5';

          > *:first-child {
            grid-area: item1;
            background-color: ${props.theme.shades.primary2};
          }

          > *:nth-child(2) {
            grid-area: item2;
            background-color: ${props.theme.shades.secondary2};
          }

          > *:nth-child(3) {
            grid-area: item3;
            background-color: ${props.theme.shades.ternary2};
          }

          > *:nth-child(4) {
            grid-area: item4;
            background-color: #e3fbff;
          }

          > *:nth-child(5) {
            grid-area: item5;
            background-color: ${props.theme.colors.backgroundAlt};
          }
        `;
      case 6:
        return `
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr 1fr 1fr;
          grid-template-areas:
            'item1 item1 item2'
            'item3 item4 item4'
            'item3 item5 item6';

          > *:first-child {
            grid-area: item1;
            background-color: ${props.theme.shades.secondary2};
          }

          > *:nth-child(2) {
            grid-area: item2;
            background-color: ${props.theme.shades.ternary2};
          }

          > *:nth-child(3) {
            grid-area: item3;
            background-color: ${props.theme.shades.primary2};
          }

          > *:nth-child(4) {
            grid-area: item4;
            background-color: ${props.theme.colors.backgroundAlt};
          }

          > *:nth-child(5) {
            grid-area: item5;
            background-color: #ffc9a0;
          }

          > *:nth-child(6) {
            grid-area: item6;
            background-color: ${props.theme.shades.primary2};
          }
        `;
    }
  }}
`;

export const TilesGroup = ({ children, count }: IProps) => {
  const { ref, itemsWithStyleProp } = useRevealTrail(children);
  return (
    <Host ref={ref} count={count}>
      {itemsWithStyleProp}
    </Host>
  );
};
